import { useEffect, useState } from 'react';

export const useScreenFullHeight = () => {
    const [height, setHeight] = useState<number | undefined>();

    useEffect(() => {
        const appHeight = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener('resize', appHeight);
        appHeight();

        return () => {
            window.removeEventListener('resize', appHeight);
        };
    }, []);

    return {
        height,
    };
};
